import app from 'flarum/common/app';

app.initializers.add('nodeloc/friend-link', () => {
});
